<div class="flex flex-col h-full flex-1 overflow-x-hidden">
  <div
    id="header"
    class="flex-shrink-0"
    [ngStyle]="getBackgroundStyles()"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    <app-block-list [blockIdList]="header"></app-block-list>
  </div>
  <div class="flex flex-1 h-full overflow-hidden">
    <div
      class="w-full h-full flex flex-1 flex-col"
      [style.backgroundColor]="backgroundColor | contentBuilderColor"
      [style.color]="textColor | contentBuilderColor"
    >
      <div class="overflow-y-auto h-full">
        <app-block-list [blockIdList]="body"></app-block-list>
      </div>
    </div>
  </div>
  <div
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    <app-block-list [blockIdList]="footer"></app-block-list>
  </div>
</div>
